module.exports = __webpack_public_path__ + "static/media/bhumika.d0bebbcc.jpg";